import Block from './Block'
import gsap from 'gsap'
import SplitType from 'split-type'
import store from '../util/store';

export default class HeroBanner extends Block {
  getElems() {
    if (!store.detect.isMobile) {
      this.svgs = Array.from(this.el.querySelector('.b-hero-banner__logo').querySelectorAll('svg'))
      this.image = {
        container: this.el.querySelector('.image'),
        visual: this.el.querySelector('.image').querySelector('img')
      }
      this.lines = Array.from(this.el.querySelector('.text').querySelectorAll('p'))
        .map((text) => new SplitType(text, {types: 'lines'}))
        .map((split) => split.lines)
        .flat()
      this.linesInners = []
      this.discover = {
        text: this.el.querySelector('.b-hero-banner__discover a'),
        line: this.el.querySelector('.b-hero-banner__discover .b-hero-banner__discover__line')
      }
    }

    this.slider = this.el.querySelector('.b-hero-banner__slider')
    this.sliderImages = Array.from(this.el.querySelectorAll('.b-hero-banner__slider .image'))
  }

  init() {

    if (!store.detect.isMobile) {
      this.lines.forEach((line) => {
        const inner = document.createElement('div')

        inner.classList.add('line__inner')
        inner.innerHTML = line.innerHTML
        line.innerHTML = ''
        this.linesInners.push(inner)
        line.appendChild(inner)
      })

      if (this.slider) {
        gsap.set(this.slider, {
          scale: 1.4
        })
      } else {
        gsap.set(this.image.container, {
          clipPath: 'inset(0% 0% 100% 0%)'
        })

        gsap.set(this.image.visual, {
          scale: 1.4
        })
      }

      gsap.set(this.svgs, {
        xPercent: -100
      })

      gsap.set(this.linesInners, {
        yPercent: 100
      })

      gsap.set(this.discover.text, {
        yPercent: -25,
        opacity: 0
      })

      gsap.set(this.discover.line, {
        scaleY: 0
      })

      this.tl = gsap.timeline({
        defaults: {
          ease: 'power3.inOut'
        }
      })

      if (this.slider) {
        this.tl.to(this.slider, {
          scale: 1,
          duration: 0.8
        })
      } else {
        this.tl.to(this.image.container, {
          clipPath: 'inset(0% 0% 0% 0%)',
          duration: 0.8
        })

        this.tl.to(this.image.visual, {
          scale: 1,
          duration: 0.8
        }, '<')
      }

      this.tl.to(this.svgs, {
        xPercent: 0,
        duration: 0.4,
        stagger: 0.02,
        ease: 'power3.out'
      }, '<0.6')

      this.tl.to(this.linesInners, {
        yPercent: 0,
        duration: 0.6,
        stagger: 0.2,
        ease: 'power3.out'
      }, '<0.2')

      this.tl.to(this.discover.text, {
        yPercent: 0,
        opacity: 1,
        duration: 0.4
      }, '<0.4')

      this.tl.to(this.discover.line, {
        scaleY: 1,
        duration: 0.4
      }, '<0.1')
    }
    if (this.slider) {

      // Slider Animation
      const sliderTl = gsap.timeline({
        repeat: -1,
        defaults: {
          duration: 1,
          ease: 'expo.inOut'
        }
      })

      // Initialize slider images
      this.sliderImages.forEach((img, i) => {
        if (i === 0) {
          gsap.set(img, {
            clipPath: 'inset(0% 0% 0% 0%)'
          })
          gsap.set(img.querySelector('.image__inner'), {
            left: '0%'
          })
        } else {
          gsap.set(img, {
            clipPath: 'inset(0% 0% 0% 100%)'
          })
          gsap.set(img.querySelector('.image__inner'), {
            left: '15%'
          })
        }
      })

      // Slider animation logic
      this.sliderImages.forEach((img, i) => {
        const nextImg = this.sliderImages[(i + 1) % this.sliderImages.length]

        sliderTl.to(img, {
          clipPath: 'inset(0% 100% 0% 0%)'
        }, '+=2')
          .to(img.querySelector('.image__inner'), {
            left: '-15%'
          }, '<')
          .to(nextImg, {
            clipPath: 'inset(0% 0% 0% 0%)'
          }, '<')
          .to(nextImg.querySelector('.image__inner'), {
            left: '0%'
          }, '<')
          .to(img, {
            clipPath: 'inset(0% 0% 0% 100%)',
            duration: 0
          })
          .to(img.querySelector('.image__inner'), {
            left: '15%'
          })
      })
    }
  }
}
